import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { CustomerReadinessQueryKeys } from "./keys";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ICustomerReadiness } from "../../models/Customer/CustomerReadiness";

export default function useCustomerReadiness(customerId: string) {
  const { get } = useApiHelper();

  const readiness = useQuery({
    queryKey: CustomerReadinessQueryKeys.single(customerId),
    queryFn: () =>
      get<IDefaultResponse<ICustomerReadiness>>(
        `/customer/${customerId}/readiness`,
      ).then((res) => res.data),
  });

  return {
    readiness,
  };
}
